import { CategoryEnum } from "~/enums";
import inactiveInsuranceStatusEnum from "~/enums/InactiveInsuranceStatusEnum";
import inactiveMortgageStatusEnum from "~/enums/InactiveMortgageStatusEnum";

const getActiveFromAttachableStatus = (attachable) => {
  switch (attachable.category) {
    case CategoryEnum.INSURANCE:
      return !inactiveInsuranceStatusEnum[attachable.attachable_status.data.status];
    case CategoryEnum.DAMAGE:
      return attachable.attachable_status.data.status < 1;
    case CategoryEnum.MORTGAGE:
      return !inactiveMortgageStatusEnum[attachable.attachable_status.data.status];
    default:
      return true;
  }
};

export default {
  getActiveFromAttachableStatus,
};
